import React from "react";
import { motion } from "framer-motion";
import { Navbar } from "./Navbar";
import Cookies from "js-cookie"
import { Link } from "react-router-dom";
function Prices() {
  const pricingPlan = {
    name: "Standard Plan",
    price: "$1.99",
    features: [
      "One-time access",
      "Resume score",
      "Recommendations",
      "10 minutes free consultation",
    ],
    icon: "💻",
  };

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.2 },
    },
  };

  const cardVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0, transition: { ease: "easeOut", duration: 0.6 } },
    hover: { scale: 1.05, transition: { duration: 0.3 } },
  };
  const token=Cookies.get('access_token');
  

  return (
    <>
      <Navbar />
      <div className="py-6 px-6 sm:px-16 bg-gray-50">
        <div className="text-center mb-12">
          <motion.h2
            className="text-4xl font-semibold text-gray-800"
            initial={{ opacity: 0, y: -40 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1 }}
          >
            Pricing Plan
          </motion.h2>
          <motion.p
            className="text-lg text-gray-600 mt-4"
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1, delay: 0.3 }}
          >
            Get access to premium features at an affordable price.
          </motion.p>
        </div>

        <motion.div
          className="flex justify-center"
          variants={containerVariants}
          initial="hidden"
          animate="visible"
        >
          <motion.article
            className="bg-white p-8 rounded-xl shadow-lg text-center transform transition-transform duration-300 hover:shadow-xl w-full max-w-lg"
            variants={cardVariants}
            whileHover="hover"
          >
            <motion.div
              className="text-5xl mb-4 p-4 inline-block rounded-full text-white bg-orange-500"
              initial={{ scale: 0 }}
              animate={{ scale: 1, transition: { duration: 0.5 } }}
            >
              {pricingPlan.icon}
            </motion.div>
            <h3 className="text-xl font-semibold text-gray-800 mb-4">{pricingPlan.name}</h3>
            <p className="text-2xl font-bold text-gray-800 mb-4">{pricingPlan.price}</p>
            <ul className="text-gray-600 mb-6 space-y-2">
              {pricingPlan.features.map((feature, idx) => (
                <li key={idx} className="flex items-center justify-center gap-2">
                  <span className="text-green-500">✔</span>
                  {feature}
                </li>
              ))}
            </ul>
            <Link to={token ? "/upload" : "/signup"}>

            <motion.button
              className="py-2 px-6 rounded-full bg-orange-500 text-white hover:bg-orange-600"
              whileTap={{ scale: 0.95 }}
            >
              Get Started
            </motion.button>
            </Link>
          </motion.article>
        </motion.div>
      </div>
    </>
  );
}

export default Prices;
